import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setChecking(false);
      return;
    }
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => setUser(false)).finally(() => setChecking(false));
  }, []);

  const value = useMemo(() => ({
    user,
    checking,
    async login(payload) {
      const { data } = await api.post("/auth/login", payload);
      setUser(data);
      return data;
    },
    async register(payload) {
      const { data } = await api.post("/auth/register", payload);
      setUser(data);
      return data;
    },
    async completeGoogleSession(sessionId) {
      const { data } = await api.post("/auth/google/session", { session_id: sessionId });
      setUser(data);
      setChecking(false);
      return data;
    },
    async refreshUser() {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    },
    async logout() {
      await api.post("/auth/logout");
      setUser(false);
    },
  }), [user, checking]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);